<section class="apq" *ngIf="verified">
  <header class="apq-head">
    <h1>Plate photos: review queue</h1>
    <p>
      Photos members have added, waiting for a decision. Nothing here is public
      yet. Approve shows the photo on the plate's timeline; reject keeps it off
      the site.
    </p>
    <button class="apq-refresh" (click)="load()" [disabled]="loading">
      {{ loading ? 'Loading…' : 'Refresh' }}
    </button>
  </header>

  <div class="apq-empty" *ngIf="error">{{ error }}</div>
  <div class="apq-empty" *ngIf="!loading && !error && !photos.length">
    Nothing pending. The queue is clear.
  </div>

  <div class="apq-grid">
    <article class="apq-card" *ngFor="let p of photos">
      <div class="apq-photo">
        <img [src]="p.imageUrl" [alt]="p.registration + ' on a car'" loading="lazy" />
        <span class="apq-reg plate-font">{{ p.registration }}</span>
      </div>
      <div class="apq-body">
        <div class="apq-car">{{ carLine(p) }}</div>
        <div class="apq-meta">
          Seen {{ p.yearSeen }} · Photo: {{ p.credit }}
        </div>
        <div class="apq-meta">Sent {{ submitted(p) }}</div>
        <a class="apq-src" [routerLink]="['/plate', p.registration]" target="_blank">plate page &#8599;</a>
      </div>
      <div class="apq-actions">
        <button
          class="apq-reject"
          (click)="reject(p)"
          [disabled]="acting.has(p.id)"
        >
          Reject
        </button>
        <button
          class="apq-approve"
          (click)="approve(p)"
          [disabled]="acting.has(p.id)"
        >
          Approve
        </button>
      </div>
    </article>
  </div>

  <div class="apq-toast" *ngIf="toast">{{ toast }}</div>
</section>
